import React from 'react'
import ImageWithBasePath from '../../core/common/imageWithBasePath'

interface BannerProps {
    apiValues1: any;
}



const Benefits: React.FC<BannerProps> = ({ apiValues1 }) => {



    return (
        <>
            {/* benefits */}
            <section className="benefit-section">
                <div className="container">
                    <div className="section-header text-start p-3">
                        <h1 className="text-red-600">
                            {apiValues1?.headingText}
                        </h1>
                        <h2 className=' text-[#1D1753] mb-2'>
                            {apiValues1?.headingDescription}
                        </h2>
                        <p>
                            {apiValues1?.headingMiniDescription}
                        </p>
                    </div>
                    <div className="row">

                        {

                            (Array.isArray(apiValues1?.headingCards) ? apiValues1?.headingCards : []).map((item: any, index: number) => {

                                return (

                                    <div className="col-lg-4 col-md-6">
                                        <div className="card shadow-sm">
                                            <div className="card-body p-4">
                                                <div className="position-absolute top-0 end-0 mt-n3 me-n4">
                                                    <ImageWithBasePath src="./assets/img/shapes/palanibgcard.png" alt="img" />
                                                </div>
                                                <div className="p-2 rounded-pill bg-[#FFEDF0] d-inline-flex">
                                                    <ImageWithBasePath
                                                        source={
                                                            item?.iconUrl
                                                        }
                                                        className="rounded-full"
                                                        style={{
height:40,
width:40
                                                        }}
                                                        
                                                        alt="Img"
                                                    />
                                                </div>
                                                <h5 className="mt-3 mb-1 text-[#1D1753]">
                                                    {item?.title}
                                                </h5>
                                                <p>
                                                    {item?.description}
                                                </p>
                                                {/* <button className="flex items-center bg-red-500 hover:bg-red-600 text-white rounded-full px-5 py-2 transition duration-300">
                                                    <span>Get started</span>
                                                    <ImageWithBasePath src="./assets/img/individual/Vector.png" alt="img" className="ml-2 text-xl" />
                                                </button> */}
                                            </div>
                                        </div>
                                    </div>
                                )
                            }) || []
                        }



                    </div>
                </div>
            </section>
        </>

    )
}

export default Benefits
